import { useEffect, useState } from "react";
import { Tabs, Typography, Flex, Button, Dropdown, Tooltip } from "antd";
import {
  DownloadOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";

import { getBusDetailedView } from "../../redux/slices/BusSlice";
import { getDropdownData } from "../../redux/slices/EnqMngtSlice";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import BackButton from "../../components/CustomButton/BackButton";
import CustomCard from "../../components/CustomCard/CustomCard";
import BusinessDetails from "./Components/BusinessDetails";
import BankKYCDetails from "./Components/BankKYCDetails";
import DirectorDetails from "./Components/DirectorDetails";
import EnterpriseDetails from "./Components/EnterpriseDetails";
import SuppliersList from "./Components/SuppliersList";
import "./Business.scss";
import { TITLE_TXT } from "../../constants/constants";
import { capitalizeEntireWord } from "../../helpers/helpers";
import { detailedViewDownloadPageHandle } from "../../helpers/helpers";
import Documents from "./Components/Documents";
import BusinessActivityLog from "./Components/BusinessActivityLog.jsx";
import { isSupplyChainCategory } from "../../helpers/dealCategoryProducts";

const { Text } = Typography;

const BusDetails = () => {
  const dispatch = useDispatch();
  const { orgId, status } = useParams();
  const location = useLocation();
  const org = location.state;
  const isJV =
    org?.dealCategoryId === "DCT1000002" ||
    org?.dealCategoryName === "Joint Ventures";
  const { busDetailedViewData } = useSelector((state) => state?.business);
  const [activeTab, setActiveTab] = useState(isJV ? "2" : "1");

  const dealCategoryId =
    org?.dealCategoryId || busDetailedViewData?.busDetails?.dealCategoryId;
  const isSupplyChain =
    isSupplyChainCategory(dealCategoryId) ||
    dealCategoryId === "DCT1000006" ||
    org?.dealCategoryName === "Supply Chain Financing" ||
    org?.dealCategoryName === "Supply Chain Finance" ||
    busDetailedViewData?.busDetails?.dealCategory === "Supply Chain Financing" ||
    busDetailedViewData?.busDetails?.dealCategory === "Supply Chain Finance";

  useEffect(() => {
    dispatch(getBusDetailedView({
      orgId,
      dealCategoryId: org?.dealCategoryId,
    })
    );

    dispatch(getDropdownData());
  }, [dispatch, orgId, org?.dealCategoryId]);

  // ✅ Real download handler
  const handleDownload = () =>
    detailedViewDownloadPageHandle({
      dispatch,
      type: "businessPdf",
      id: orgId,
    });
  // 🔽 Dropdown menu items
  const downloadItems = [
    {
      key: "pdf",
      label: "Download as PDF",
      icon: <FilePdfOutlined />,
    },
    // {
    //     key: "excel",
    //     label: "Download as Excel",
    //     icon: <FileExcelOutlined />,
    // },
  ];

  const items = [
    !isJV && {
      key: "1",
      label: capitalizeEntireWord(TITLE_TXT.ENT_DETS),
      children: (
        <EnterpriseDetails
          enterpriseDetailsData={busDetailedViewData?.enterprise}
          dealCategoryId={dealCategoryId}
          dealCategoryName={
            org?.dealCategoryName ||
            busDetailedViewData?.busDetails?.dealCategoryName ||
            busDetailedViewData?.busDetails?.dealCategory
          }
        />
      ),
    },
    {
      key: "2",
      label: capitalizeEntireWord(TITLE_TXT.BUS_DETS),
      children: (
        <BusinessDetails
          businessDetailesData={busDetailedViewData}
          orgId={orgId}
          status={status}
        />
      ),
    },
    {
      key: "3",
      label: capitalizeEntireWord(TITLE_TXT.BANK_KYC_DETS),
      children: (
        <BankKYCDetails
          bankKYCDetailsData={busDetailedViewData}
          isJV={isJV}
        />
      ),
    },
    {
      key: "4",
      label: capitalizeEntireWord(TITLE_TXT.DIR_DETS),
      children: <DirectorDetails directorDetailsData={busDetailedViewData} />,
    },
    {
      key: "5",
      label: capitalizeEntireWord(TITLE_TXT.DOCS),
      children: (
        <Documents
          orgId={orgId}
          org={org}
          dealCategoryId={org?.dealCategoryId || busDetailedViewData?.busDetails?.dealCategoryId}
        />
      ),
    },
    isSupplyChain && {
      key: "7",
      label: capitalizeEntireWord(TITLE_TXT.SUPPLIERS_LIST || "Suppliers List"),
      children: (
        <SuppliersList
          suppliersData={busDetailedViewData?.suppliers}
          orgId={orgId}
        />
      ),
    },
    
    {
      key: "6",
      label: "ACTIVITY LOG",
      children: (
        <BusinessActivityLog
          orgId={orgId}
          businessName={busDetailedViewData?.busDetails?.busName}
          dealCategoryId={org?.dealCategoryId}
        />
      ),
    },
  ].filter(Boolean);

  return (
    <div className="bus-details-container">
      {/* Back button + title */}
      <Flex align="center" style={{ marginBottom: 16 }}>
        <BackButton />

        <Text className="name" style={{ marginLeft: 24 }}>
          {`Viewing Details for ${busDetailedViewData?.busDetails?.busName || ""
            }`}
        </Text>
      </Flex>

      <CustomCard>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="bus-details-tabs"
          tabBarExtraContent={
            !["5", "6", "7"].includes(activeTab) && (
              <Flex align="center" gap={12}>
                <Dropdown
                  menu={{
                    items: downloadItems,
                    onClick: handleDownload,
                  }}
                  placement="bottomRight"
                >
                  <Tooltip title="Download">
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<DownloadOutlined />}
                      disabled={!busDetailedViewData}
                    />
                  </Tooltip>
                </Dropdown>
              </Flex>
            )
          }
        />
      </CustomCard>
    </div>
  );
};

export default BusDetails;
